import React, { useState, useEffect } from "react";
import "./HomePage.scss";
import About from "../about/About";
import Experience from "../experience/Experience";
import Contact from "../contact/Contact";
import Works from "../works/Works";

const sections = ["about", "experience", "works", "contact"];

const HomePage = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("about");
  const handleLinkedinClick = () =>
    window.open("https://www.linkedin.com/in/tetiana-korchynska/", "_blank");
  const handleBehanceClick = () =>
    window.open("https://www.behance.net/0031c316", "_blank");

  const handleGithubClick = () =>
    window.open("https://github.com/Taniatos", "_blank");

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }

      // Detect active section
      let current = "about"; // default
      sections.forEach((id) => {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            current = id;
          }
        }
      });
      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (e, id) => {
    e.preventDefault();
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const getLabel = (id) => {
    const fullNames = {
      about: "ABOUT",
      experience: "EXPERIENCE",
      works: "WORKS",
      contact: "CONTACT",
    };

    const shortNames = {
      about: "AB",
      experience: "EX",
      works: "WR",
      contact: "CN",
    };

    if (!scrolled) {
      // If homepage (no scroll yet) → always full names
      return fullNames[id];
    } else {
      // If small nav → active section full, others short
      return activeSection === id ? fullNames[id] : shortNames[id];
    }
  };

  return (
    <div className="homepage-wrapper">
      <div className={`homepage ${scrolled ? "nav-small" : ""}`}>
        <main className="main-content">
          <nav className={`nav-links ${scrolled ? "small" : ""}`}>
            {sections.map((id) => (
              <a
                key={id}
                href={`#${id}`}
                onClick={(e) => handleNavClick(e, id)}
                className={activeSection === id ? "active-link" : ""}
              >
                {getLabel(id)}
              </a>
            ))}
          </nav>

          <div className="intro">
            <h2>TETIANA KORCHYNSKA</h2>
            <p>Full-Stack Product Engineer</p>

            <div className="socials">
              <span
                className="li"
                data-abbr="LI"
                data-full="LinkedIn"
                onClick={handleLinkedinClick}
              ></span>
              <span
                className="be"
                data-abbr="BE"
                data-full="Behance"
                onClick={handleBehanceClick}
              ></span>
              <span
                className="gh"
                data-abbr="GH"
                data-full="GitHub"
                onClick={handleGithubClick}
              ></span>
            </div>
          </div>
        </main>
      </div>

      {/* --- Sections --- */}
      <section id="about" className="page-section main-about-section">
        <About />
      </section>

      <section id="experience" className="page-section main-experience-section">
        <Experience />
      </section>

      <section id="works" className="page-section main-works-section">
        <Works />
      </section>

      <section id="contact" className="page-section main-contact-section">
        <Contact />
      </section>
    </div>
  );
};

export default HomePage;
